export default __webpack_public_path__ + "static/media/n4.efb7f7d0.jpg";